import { AgeMapper } from './age';
import { CallingStatusMapper } from './callingStatus';
import { CommsPreferencesMapper } from './commsPreferences';
import { EngagementHistoryMapper } from './engagementHistory';
import { EventAttendanceMapper } from './eventAttendance';
import type { FilterMapper } from './filterMapperTypes';
import { GeometryIdsMapper } from './geometryIds';
import { GroupIdsMapper } from './groupIds';
import { HasEmailMapper } from './hasEmail';
import { HasPhoneMapper } from './hasPhone';
import { ListIdsMapper } from './listIds';
import { MailingMapper } from './mailing';
import { MembershipMapper } from './membership';
import { PathwayStepsMapper } from './pathwaySteps';
import { RosterMapper } from './roster';
import { Sa1Mapper } from './sa1';
import { SupporterStatusesMapper } from './supporterStatuses';
import { TagIdsMapper } from './tagIds';
import { TaskMapper } from './task';

export type {
  FilterMapper,
  MapQbRulePropertiesToSearchFilterOptions,
  MappingError,
  ValidationContext,
} from './filterMapperTypes';

export const FilterMappers: Record<string, FilterMapper> = {
  hasPhone: HasPhoneMapper,
  hasEmail: HasEmailMapper,
  geometryIds: GeometryIdsMapper,
  tagIds: TagIdsMapper,
  groupIds: GroupIdsMapper,
  supporterStatuses: SupporterStatusesMapper,
  pathwaySteps: PathwayStepsMapper,
  listIds: ListIdsMapper,
  age: AgeMapper,
  membership: MembershipMapper,
  task: TaskMapper,
  mailing: MailingMapper,
  roster: RosterMapper,
  eventAttendance: EventAttendanceMapper,
  engagementHistory: EngagementHistoryMapper,
  callingStatus: CallingStatusMapper,
  commsPreferences: CommsPreferencesMapper,
  sa1: Sa1Mapper,
};
